import { Achievement, AchievementBonus, AchievementBonusType, AchievementMissionType } from '../models/achievement.model';
import { Item } from '../models/items.model';

// Function to match a pattern against an item's unique name
// Function to check if an item's unique name matches any pattern in the AchievementBonus
export const matchesPattern = (bonus: AchievementBonus, itemName: string): boolean => {
  return (
    bonus.itemPattern?.some((pattern) => {
      const regexPattern = pattern.replace('?', '\\d').replace('*', '.*');
      const regex = new RegExp('^' + regexPattern + '$');
      return regex.test(itemName);
    }) || false
  ); // Return false if there's no itemPattern or no match
};
export const findMatchingAchievements = (
  achievements: Achievement[],
  item: Item,
  missionType: AchievementMissionType | AchievementMissionType[]
): Achievement[] =>
  achievements.filter(
    (achievement) =>
      (Array.isArray(missionType) ? missionType.includes(achievement.missionType) : achievement.missionType === missionType) &&
      achievement.achievementBonus?.some((bonus) => matchesPattern(bonus, item.originalUniqueName))
  );

export const getFocusEfficiency = (userAchievements: Achievement[], item: Item, bonusType: AchievementBonusType | AchievementBonusType[]): number => {
  let result = 0;
  for (let ach of userAchievements) {
    if (ach.achievementBonus) {
      for (let bonus of ach.achievementBonus) {
        if (
          (Array.isArray(bonusType) ? bonusType.includes(bonus.type) : bonus.type === bonusType) &&
          matchesPattern(bonus, item.originalUniqueName) &&
          bonus.minTier <= (item.tier ?? 0) &&
          bonus.maxTier >= (item.tier ?? 0)
        ) {
          result += bonus.bonus * 100 * (ach.playerLevel ?? 0);
        }
      }
    }
  }
  return result;
};

export const getFocusEfficiencyText = (ach: Achievement, item: Item, bonusType: AchievementBonusType | AchievementBonusType[]): string => {
  let result = '';
  let i = 0;
  if (ach.achievementBonus)
    for (let bonus of ach.achievementBonus) {
      if (
        (Array.isArray(bonusType) ? bonusType.includes(bonus.type) : bonus.type === bonusType) &&
        matchesPattern(bonus, item.originalUniqueName) &&
        bonus.minTier <= (item.tier ?? 0) &&
        bonus.maxTier >= (item.tier ?? 0)
      )
        result += i === 0 ? bonus.bonus * 100 : ' + ' + bonus.bonus * 100;
      i++;
    }
  return (result || '0') + ' per level';
};
